import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Assets } from '@freelancer/ui/assets';
import { LinkUnderline } from '@freelancer/ui/link';
import { ListItemPadding } from '@freelancer/ui/list-item';
import { AvatarSize } from '@freelancer/ui/user-avatar';
import type { UsernameOrEmail, ValidatedUser } from '../../invitation.model';

@Component({
  selector: 'app-create-invitation-list',
  template: `
    <fl-scrollable-content class="ScrollableContent">
      <fl-list
        [bodyEdgeToEdge]="true"
        [outerPadding]="false"
        [padding]="ListItemPadding.XXSMALL"
      >
        <fl-list-item
          *ngFor="
            let validatedUser of validatedUsers;
            trackBy: trackByUserIdOrEmailAddress
          "
        >
          <fl-bit class="ContentContainer">
            <fl-bit class="ContentContainer">
              <fl-user-avatar
                [flMarginRight]="'xsmall'"
                [size]="AvatarSize.SMALL"
                [users]="[
                  validatedUser.email
                    ? { avatar: UnknownAvatar }
                    : validatedUser.user
                ]"
              ></fl-user-avatar>
              <fl-text>
                {{ validatedUser.user?.username ?? validatedUser.email }}
                <ng-container
                  *ngIf="
                    !hideText &&
                    (validatedUser.user?.id != ownerId || validatedUser.email)
                  "
                >
                  <ng-container
                    *ngIf="validatedUser.invitationId"
                    i18n="User already invited to team text"
                  >
                    has been invited to your team
                  </ng-container>
                  <ng-container
                    *ngIf="!validatedUser.invitationId"
                    i18n="User invited to team text"
                  >
                    will be invited to your team
                  </ng-container>
                </ng-container>
              </fl-text>
            </fl-bit>

            <fl-link
              *ngIf="validatedUser.user?.id != ownerId || validatedUser.email"
              class="RemoveLink"
              i18n="Create invitation list remove invitee link"
              flTrackingLabel="RemoveInvitee"
              [underline]="LinkUnderline.NEVER"
              (click)="handleRemoveInvitee(validatedUser)"
            >
              Uninvite
            </fl-link>
          </fl-bit>
        </fl-list-item>
      </fl-list>
    </fl-scrollable-content>
  `,
  styleUrls: ['./create-invitation-list.component.scss'],
})
export class CreateInvitationListComponent {
  AvatarSize = AvatarSize;
  LinkUnderline = LinkUnderline;
  ListItemPadding = ListItemPadding;
  UnknownAvatar = this.assets.getUrl('unknown.png');

  @Input() validatedUsers: readonly ValidatedUser[];
  @Input() ownerId: number;
  @Input() hideText = false;

  @Output() removeInvitation = new EventEmitter<number>();
  @Output() removeInvitee = new EventEmitter<UsernameOrEmail>();

  constructor(private assets: Assets) {}

  handleRemoveInvitee(invitee: ValidatedUser): void {
    if (invitee.invitationId) {
      this.removeInvitation.emit(invitee.invitationId);
    } else if (invitee.user) {
      this.removeInvitee.emit({
        type: 'username',
        value: invitee.user.username,
      });
    } else {
      this.removeInvitee.emit({
        type: 'email',
        value: invitee.email,
      });
    }
  }

  trackByUserIdOrEmailAddress(
    _: number,
    item: ValidatedUser,
  ): string | number | undefined {
    // FIXME: T276026 Track by functions shouldn't return `undefined`
    return item.user?.id ?? item.email;
  }
}
